import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation } from 'react-router-dom'
import http from '../../../config/BaseUrl'
import LoginImage from '../../../assets/images/login.jpg'
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'
import '../style/style.css'
import { FiCheckCircle } from 'react-icons/fi'

const ResendEmail = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")

  const { register, handleSubmit, setError, formState: { errors } } = useForm({ mode: "all", reValidateMode: "onChange" })

  const handelResendEmail = (data) => {

  }

  // Resend Code
  const ResendCode = async () => {
    try {
      const userInfo = {
        id: history.location.state.id,
        email: history.location.state.email,
      }
      setLoading(true)
      await http.post("email/resend", userInfo).then((res) => {
        setMessage(res.data.message);
        setLoading(false)
      })
    } catch (error) {
      console.log(error.message);
      setLoading(false)
    }
  }
  return (
    // <>
    //     <div className="section-authentication-login">
    //     <div className="row h-100">
    //       <div className="mx-auto my-auto col-lg-4">
    //         <div className="card radius-15">
    //           <div className="row no-gutters">
    //             <div className="col-lg-12">
    //               <div className="card-body p-md-5">
    //                 <div className="text-center">
    //                   <img src="assets/images/logo.png" width={80} alt="" />
    //                   <h3 className="mt-4 font-weight-bold">Resend Email</h3>
    //                 </div>
    //                 <div className="text-center">
    //                 {message ? (
    //                   <div class="alert alert-success alert-dismissible fade show" role="alert">{message}
    //                     <button type="button" class="close" data-dismiss="alert" aria-label="Close">	<span aria-hidden="true">×</span>
    //                     </button>
    //                   </div>
    //                 ) : ("")}
    //                 </div>

    //                 <form onSubmit={handleSubmit(handelResendEmail)}>
    //                   <div className="mt-3 btn-group w-100">

    //                     <button type="button" onClick={ResendCode} className="btn btn-primary btn-block">
    //                     {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) 
    //                       : ("Resend")
    //                     }
    //                     </button>
    //                   </div>
    //                 </form>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </>

    <>
      <div className="section-authentication-login p-md-0 p-3">
        <div className="container-fluid px-0">

          <div className="row h-100">
            <div className="col-md-6 d-none d-md-block">
              <div className="page-image">
                <div className="login-header mt-5">
                  <div className="logo">
                    <img src={Logo} className="img-fluid" alt="haylo" />
                  </div>


                </div>
                <div className="image-body">
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-body">
                <div className="row justify-content-center align-items-center h-100">
                  <div className="col-12">
                    <p className="text-secodary font-weight-bold text-right pr-5">{/* Don’t have an account? */} {/* <Link to="/register">Sign up now</Link> */}</p>
                  </div>
                  <div className="col-md-7 col-sm-8 col-12">
                    <div className="mx-auto my-auto h-100">
                      <div className="p-md-3">
                        <div className="text-left">
                          <h3 className="mb-4 font-weight-bold">Resend Email</h3>
                        </div>
                        <div className="text-center">
                          {message ? (
                            <div class="alert alert-success alert-dismissible fade show" role="alert">{message}
                              <button type="button" class="close" data-dismiss="alert" aria-label="Close">	<span aria-hidden="true">×</span>
                              </button>
                            </div>
                          ) : ("")}
                        </div>
                        <div class="border p-3 radius-10" role="alert">
                          <p><span><FiCheckCircle color={"#CEA252"} /> </span>A verification link has been sent to your email account</p> <hr />
                          Please click on the link that has just been sent to your email account to verify your email and continue the registration process.
                        </div>
                        <form onSubmit={handleSubmit(ResendCode)}>

                          <div className="mt-3 btn-group w-100">
                            <button type="submit" className="btn btn-primary btn-block">
                              {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                                : ("Resend")
                              }
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <p className="text-right font-weight-bold pr-5">{/* <Link to="/forgot">Forgot Password?</Link> */}</p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

    </>
  )
}

export default ResendEmail
